import { Container } from "reactstrap"
import { useEffect } from "react"
import Speech from 'react-speech';
import Helmet from "react-helmet"
import { CustomInput, CustomButton, Modal } from "../components"
import { COLORS } from "../constants"
import Logo from "../assets/images/logo.png"
import styled from "styled-components"
import grass from "../assets/images/grass.svg"
import speaker from "../assets/images/speaker.svg"
import { useQuery } from "../features"
import { Swiper, SwiperSlide } from 'swiper/react';
import ReactLoading from "react-loading"
import { Link } from "react-router-dom"
import axios from "axios"
import { useSelector } from "react-redux"

import gameplay_pig from "../assets/images/gameplay_pig.svg"
import { useState } from "react"
import Loading from "./Loading"
import { useHistory } from "react-router-dom";
import useSound from "use-sound";
import wrongAnswer from "../assets/audio/wrong.wav"
import correctAnswer from "../assets/audio/correct.wav"
import { replace } from "../features"

const StyledInfo = styled.div`
    position: absolute;
    top: 20px;
    left: 40px;
`;
const StyledGrass = styled.div`
    width: 100%;
    background-image: url(${grass});
    /* padding-top: 50%; */
    height: 120px;
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    bottom: 0;

`;
// Progress Bar. Later will be separated to another component.

const StyledProgressWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    height: 17px;
    width: 100%;
    background-color: #0C5F7D;
    border-radius: 50px;
   
`;
const StyledProgressCircle = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 35px;
    height: 35px;
    color: ${props => props.correct ? COLORS.text_dark_green : props.incorrect ? "#731D1D" : "#0B3146"};
    border-radius: 50%;
    margin-top: -10px;
    background-color: ${props => props.correct ? COLORS.green : props.incorrect ? "#E33838" : "#0C5F7D"};
    transform: ${props => props.current ? "scale(1.2)" : "none"};
    transition: all 0.2s;
`;
const StyledSpeakerButton = styled.img`
    position: absolute;
    cursor: pointer;
    transition: opacity 0.2s;
    &:hover{
        opacity: 0.5;
    }
`;
const config = {
    angle: 90,
    spread: 360,
    startVelocity: 40,
    elementCount: 70,
    dragFriction: 0.12,
    duration: 3000,
    stagger: 3,
    width: "10px",
    height: "10px",
    perspective: "500px",
    colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"]
};

function TryAgainGameplay(props) {
    const [swiper, setSwiper] = useState(null);
    const user = useSelector(state => state.auth.user.user)
    const history = useHistory();
    const api = process.env.REACT_APP_API_URL;
    const { levelno, gameno, crr_game_id } = props.match.params;
    const [value, setValue] = useState('');
    const [playWrong] = useSound(wrongAnswer, { interrupt: true, volume: 0.7 });
    const [playCorrect] = useSound(correctAnswer, { interrupt: true, volume: 0.7 });
    const [questions, setQuestions] = useState([]);
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(true)
    const [questionAnswers, setQuestionAnswers] = useState([]);
    const [currentQuestionID, setCurrentQuestionID] = useState(0);
    const [modalVisible, setModalVisible] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);

    const updateItem = (i, value) => {
        const newItems = [...questionAnswers];
        newItems[i].answer = value;
        setQuestionAnswers(newItems);
    }
    const createPopulate = (length) => {
        const arr = new Array(length);
        for (let i = 0; i < arr.length; i++) {
            if (i == 0) {
                arr[i] = { id: 0, answer: 1 };
            } else {
                arr[i] = { id: 1, answer: 0 };
            }
        }
        return arr;
    }

    useEffect(async () => {
        console.log(user.pupil_id)
        const response = await axios.get(`${api}/ts/cp_get_retry_questions/${user.pupil_id}/${levelno}`)
        const data = response.data;
        if (data) {
            setTimeout(() => {
                setLoading(false);
            }, 1000);

            if (data.status == "error") {
                setError(true)
            } else {
                setQuestions(data.data);
                setQuestionAnswers(createPopulate(data.data.length))

            }

        }

    }, []);
    const checkCorrectAnswers = () => {
        let count = 0;
        questionAnswers.map(item => {
            if (item.answer == 2) {
                count += 1;
            }

        })
        return count;
    }
    const handleNextClick = (event) => {
        event.preventDefault()
        if (value.trim() == 0) {
            return alert("Please enter your answer")
        } else {
            if (currentQuestionID < questions.length - 1) {
                setValue("")
                setSubmitLoading(true)
                console.log(questions[currentQuestionID].question_id)
                axios.post(`${api}/ts/cp_update_retry_question`, {
                    pupil_id: user.pupil_id,
                    level_no: levelno,
                    question_id: questions[currentQuestionID].question_id, //question id instead
                    question_no: questions[currentQuestionID].question_no,
                    answer: value.toLowerCase()
                },
                    {
                        headers: {
                            'Accept': 'application/json'
                        }
                    }).then(res => {

                        setSubmitLoading(false)

                    }).catch(error => {
                        console.log(error);
                    });


                if (value.toLowerCase() == questions[currentQuestionID].word) {
                    playCorrect();
                    updateItem(currentQuestionID, 2);
                    updateItem(currentQuestionID + 1, 1);
                }
                else {
                    playWrong();
                    updateItem(currentQuestionID, 3);
                    updateItem(currentQuestionID + 1, 1);
                }
                slideTo(currentQuestionID + 1)
                setCurrentQuestionID(currentQuestionID + 1)

            } else if (currentQuestionID == questions.length - 1) {
                setSubmitLoading(true)
                if (value.toLowerCase() == questions[currentQuestionID].word) {
                    playCorrect();
                    updateItem(currentQuestionID, 2);

                }
                else {
                    playWrong();
                    updateItem(currentQuestionID, 3);

                }
                console.log(questions[currentQuestionID].question_id)
                axios.post(`${api}/ts/cp_update_retry_question`, {
                    pupil_id: user.pupil_id,
                    level_no: levelno,
                    question_id: questions[currentQuestionID].question_id,
                    question_no: questions[currentQuestionID].question_no,
                    answer: value.toLowerCase()
                },
                    {
                        headers: {
                            'Accept': 'application/json'
                        }
                    }).then(res => {
                        setModalVisible(true)
                        setSubmitLoading(false)

                    }).catch(error => {
                        console.log(error);
                    });
            }
        }
    }
    const slideTo = (index) => swiper.slideTo(index);
    if (error) {
        return <div>
            <Helmet>
                <style type="text/css">{`
                    body {
                        background-color: #3290B5;
                    }
                `}</style>
            </Helmet>
            <StyledInfo className="d-none d-md-block">
                <Link to="/dashboard">
                    <img src={Logo} width={180} height={45} />
                </Link>
                <div className="text-white">Level {levelno}</div>
                <div className="text-white">Try Again Zone</div>
            </StyledInfo>
            <div className="d-flex justify-content-center flex-column align-items-center p-3" style={{ height: "100vh" }}>
                <div className="text-center bg-white p-4 store-card" style={{ borderRadius: 10 }}>
                    <div>The level/game combination has not been purchased by the parent/teacher</div>
                    <CustomButton
                        bgColor={COLORS.green}
                        hover={COLORS.text_green}
                        className="next mt-3"
                        onClick={() => history.replace('/dashboard')}
                        color={COLORS.text_dark_green}
                        style={{ padding: "0 15px", height: 50, fontSize: 17 }}
                    >
                        Go to Dashboard
                    </CustomButton>
                </div>
            </div>
        </div>
    } else {
        return (
            <>
                <Modal modalVisible={modalVisible} width="30%">
                    <h4 className="color-text-dark-blue text-center">Results</h4>
                    <div className="text-center">Your game results have been updated</div>
                    <h1 className="text-center mt-2"><span className="color-orange">{checkCorrectAnswers()}</span><span className="color-dark-orange">/{questionAnswers.length}</span></h1>



                    <CustomButton
                        bgColor={COLORS.orange}

                        hover={COLORS.orange_hover}
                        color={COLORS.dark_orange}
                        onClick={() => history.replace('/dashboard/try_again')}
                        style={{ padding: "0 15px", height: 40, fontSize: 17, width: "100%" }}
                    >
                        Try Again Zone
                    </CustomButton>
                    <CustomButton
                        bgColor={COLORS.green}
                        hover={COLORS.darker_green}
                        color={COLORS.text_dark_green}
                        onClick={() => history.replace('/dashboard')}
                        style={{ padding: "0 15px", height: 40, fontSize: 17, width: "100%", marginTop: 10 }}
                    >
                        Exit
                    </CustomButton>

                </Modal>
                <Loading visible={loading} />

                <div className="d-flex justify-content-center flex-column align-items-center">
                    <Helmet>
                        <style type="text/css">{`
                    body {
                        background-color: #3290B5;
                    }
                `}</style>
                    </Helmet>

                    <StyledInfo className="d-none d-md-block">
                        <Link to="/dashboard">
                            <img src={Logo} width={180} height={45} />
                        </Link>
                        <div className="text-white">Level {levelno} • Try Again Zone</div>

                    </StyledInfo>
                    <div className="d-flex justify-content-center flex-column align-items-center text-center gameplay-content">
                        <div className="position-relative">
                            <div className="mt-3">
                                <img src={gameplay_pig} className="gameplay-pig" />
                                {questions.length != 0 && <h5 className="text-center position-absolute w-100 color-very-dark-blue" style={{ bottom: 20, whiteSpace: "nowrap" }}>{questions[currentQuestionID].type}</h5>}
                                {/* <div className="position-absolute" style={{ right: -20, top: 120 }}>
                                    <div className="position-relative speech" style={{ zIndex: 99, top: 0 }} >
                                        <StyledSpeakerButton src={speaker} />
                                        {questions.length && <Speech text={questions[currentQuestionID].clue} voice="Google UK English Male"></Speech>}
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        {questions.length &&
                            <Swiper onSwiper={setSwiper} slidesPerView={1} className="w-100" navigation={{ nextEl: '.next' }} autoHeight={true} allowTouchMove={false}>

                                {questions.map((question, i) => {

                                    return (
                                        <SwiperSlide key={i}>
                                            <div className="text-white mt-3" style={{ fontSize: 18 }}>Level {levelno} • Game {question.game_no}</div>
                                            <div className="text-white mt-3" style={{ fontSize: 20 }}>{replace(question.clue)}</div>
                                            <div className="color-green mt-3" style={{ fontSize: 19 }}>{question.word.length} letters • first letter is {questions[currentQuestionID].word.charAt(0).toUpperCase()}</div>
                                            <CustomInput maxLength={question.word.length} name="text" className="w-100 mt-1 color-very-dark-blue" style={{ textAlign: "center", fontSize: 20, height: 60 }} value={value} onChange={(event) => setValue(event.target.value)} />
                                        </SwiperSlide>
                                    )
                                })}

                            </Swiper>
                        }
                        <div className="d-flex mt-4 justify-content-between w-100">
                            <CustomButton
                                bgColor={COLORS.orange}

                                hover={COLORS.orange_hover}
                                color={COLORS.dark_orange}
                                onClick={() => history.replace('/dashboard/try_again')}
                                style={{ padding: "0 15px", height: 60, fontSize: 17, width: "45%" }}
                            >
                                Close Game
                            </CustomButton>
                            <CustomButton
                                bgColor={COLORS.green}
                                hover={COLORS.text_green}
                                onClick={event => handleNextClick(event)}
                                color={COLORS.text_dark_green}
                                disabled={modalVisible}
                                style={{ padding: "0 15px", height: 60, fontSize: 17, width: "45%" }}
                            >
                                {submitLoading && <ReactLoading type="spin" color={COLORS.text_dark_green} height={20} width={20} className="d-inline-block mr-2" />}
                                {currentQuestionID == questionAnswers.length - 1 ? "Finish" : "Next"}
                            </CustomButton>

                        </div>
                        <StyledProgressWrapper className="mt-5">
                            {questionAnswers.map((answer, i) => {
                                return <StyledProgressCircle current={answer.answer == 1} correct={answer.answer == 2} incorrect={answer.answer == 3} key={i}>
                                    <h5 className="mb-0">{i + 1}</h5>
                                </StyledProgressCircle>
                            })}


                        </StyledProgressWrapper>

                    </div>
                    {/* <StyledGrass /> */}


                </div>
            </>

        );
    }
}

export default TryAgainGameplay;